import { UserChecklistProgress } from "../store/clubChecklistSlice";

export type ChecklistStateKey = keyof Pick<
  UserChecklistProgress,
  "step1Complete" | "step2Complete" | "step3Complete" | "step4Complete" | "step5Complete" | "step6Complete"
>;

export interface StepConfig {
  stepNumber: number;
  description: string;
  ctaPath?: string;
  stateKey: ChecklistStateKey;
  isLocked?: boolean;
  hints: string[];
}

export const CHECKLIST_TITLE = "P49 Forecast Club Onboarding";

export const CHECKLIST_STEPS: StepConfig[] = [
  {
    stepNumber: 1,
    description: "Ask a question",
    ctaPath: "/home/ai-analyst",
    stateKey: "step1Complete",
    hints: [
      "Click this step to go to the AI Analyst chat",
      "Type any question and send it to complete this step",
    ],
  },
  {
    stepNumber: 2,
    description: "Set up your Persona",
    ctaPath: "/onboarding-v2",
    stateKey: "step2Complete",
    hints: [
      "Click this step to open persona onboarding",
      "Create a new Persona to complete this step",
    ],
  },
  {
    stepNumber: 3,
    description: "Download data from a graph",
    ctaPath: "/home/ai-analyst",
    stateKey: "step3Complete",
    hints: [
      "Click this step to go to the AI Analyst chat",
      "Ask a graph question and download a graph from the chat",
    ],
  },
  {
    stepNumber: 4,
    description: "Set up a Schedule",
    stateKey: "step4Complete",
    isLocked: true,
    hints: [
      "This feature is coming soon",
      "You'll be able to use /schedule command in the AI Analyst",
    ],
  },
  {
    stepNumber: 5,
    description: "Complete 3 days of Usage",
    stateKey: "step5Complete",
    hints: [
      "Log in and use the platform on 3 separate days",
      "This step completes automatically as you use the app",
    ],
  },
  {
    stepNumber: 6,
    description: "Subscribe to a plan",
    ctaPath: "/home/subscriptions",
    stateKey: "step6Complete",
    hints: [
      "Choose a subscription plan that fits your needs",
      "This step completes automatically when your subscription is confirmed",
    ],
  },
];

const activeSteps = CHECKLIST_STEPS.filter((s) => !s.isLocked);

export const CHECKLIST_TOTAL_COUNT = activeSteps.length;

export const getChecklistCompletedCount = (
  checklist: UserChecklistProgress
): number => activeSteps.filter((s) => checklist[s.stateKey]).length;

export const hasAnyStepComplete = (
  checklist: UserChecklistProgress
): boolean => activeSteps.some((s) => checklist[s.stateKey]);
